import { lazy } from "react"

export const Offers = lazy(() => import("views/offers/Offer"))
export const OffersDataGrid = lazy(() => import("components/offersDataGrid/OffersDataGrid"))
export const PlanFormModal = lazy(() => import("views/offers/components/PlanFormModal"))